import {
  createHookStore,
  createUseSelector,
  STORE_NAMES
} from '@namespace/helpers-store';

export const initialState = {
  feed: {
    games: { data: {}, ids: [], isLoaded: false },
    categories: { data: {}, ids: [], isLoaded: false },
    providers: { data: {}, ids: [], isLoaded: false },
    isLoading: false,
    isLoaded: false,
    platform: null
  },
  isLoaded: false
};

export const useVirtualSportsStore = createHookStore(
  STORE_NAMES.VIRTUAL_SPORTS,
  initialState
);

export const useVirtualSportsSelector = createUseSelector(
  useVirtualSportsStore
);
